var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrIndent = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zM12.5 16a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "fi-rr-indent_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44 13.045 8.375 15a.5.5 0 0 0 .71 0 .5.5 0 0 0 0-.71l-1.78-1.79H17.5a.5.5 0 0 0 0-1H7.275l1.81-1.81a.5.5 0 0 0 0-.69.5.5 0 0 0-.71 0L6.44 10.925a1.5 1.5 0 0 0 0 2.12"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "fi-rr-indent_svg__a"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  })))));
};
export { SvgFiRrIndent as ReactComponent };
export default __webpack_public_path__ + "d8a7104551cdbca7e9558e82db5e6f6d.svg";